export default __webpack_public_path__ + "static/img/bush.cd5b5e8.jpg";